module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"labelI18n.en":"Label(En)","labelI18n.de":"Label(De)","labelSearch":"Search","refresh":"Refresh","actions":"Actions"},"de":{"labelI18n.en":"Label(En)","labelI18n.de":"Label(De)","labelSearch":"Suchen","refresh":"Refresh","actions":"Actionen"}}')
  delete Component.options._Ctor
}
